// src/reviews/reviewsApi.ts
import { apiClient } from "@maat/api-base";
var reviewsApi = {
  createReview: async (bookingId, payload) => {
    return apiClient.post(`/booking/api/bookings/${bookingId}/reviews`, payload);
  },
  /** PUBLIC — no user id or booking id on these rows. See PublicReview. */
  listListingReviews: async (listingId, params) => {
    return apiClient.get(`/booking/api/listings/${listingId}/reviews`, { params });
  },
  getBookingReview: async (bookingId) => {
    return apiClient.get(`/booking/api/bookings/${bookingId}/review`);
  },
  getReview: async (reviewId) => {
    return apiClient.get(`/booking/api/reviews/${reviewId}`);
  },
  createReply: async (reviewId, body) => {
    return apiClient.post(`/booking/api/reviews/${reviewId}/replies`, { body });
  },
  /**
   * `topics` lists only subjects at least one review actually raised. `tags` is the
   * PUBLIC cut: compliments only, each picked by more than one guest.
   */
  getListingAggregate: async (listingId) => {
    return apiClient.get(`/booking/api/listings/${listingId}/reviews/aggregate`);
  },
  // Workspace-scoped (host dashboard) — workspace_id is resolved server-side from the cookie.
  listWorkspaceReviews: async (params) => {
    return apiClient.get(`/booking/api/workspace/reviews`, { params });
  },
  getWorkspaceAggregate: async () => {
    return apiClient.get(`/booking/api/workspace/reviews/aggregate`);
  },
  /** Every tag guests picked, issues included — the host's own reviews only. */
  getWorkspaceReviewTags: async (params) => {
    return apiClient.get(`/booking/api/workspace/reviews/tags`, { params });
  },
  // Public Host Profile (guest-facing) — workspace_id is a path param.
  /** PUBLIC — no user id or booking id on these rows. See PublicReview. */
  listHostReviews: async (workspaceId, params) => {
    return apiClient.get(`/booking/api/hosts/${workspaceId}/reviews`, { params });
  },
  getHostStats: async (workspaceId) => {
    return apiClient.get(`/booking/api/hosts/${workspaceId}/stats`);
  },
  /** PUBLIC — counts and averages across every listing the host runs. */
  getHostReviewSummary: async (workspaceId) => {
    return apiClient.get(`/booking/api/hosts/${workspaceId}/reviews/aggregate`);
  }
};

export {
  reviewsApi
};
